<div class="container-fluid align_filters">
    <div class="row mb-3">
        <div class="col-md-3">
            <ds-form-field>
                <label ds-label for="carBrand1" class="form-label">Brand<span style="color: red">*</span></label>
                <ds-select
                        id="carBrand1"
                        [labellingConfig]="{ placeholder: 'Select a brand...' }"
                        [options]="brandOptions()"
                        [ngModel]="filters().brand"
                        (optionSelected)="onBrandChange($event)"
                        required
                        [showClearAll]="true"
                ></ds-select>
            </ds-form-field>
        </div>

        <div class="col-md-2">
            <ds-form-field>
                <label ds-label for="carVersion1" class="form-label">Version</label>
                <ds-select
                        id="carVersion1"
                        [labellingConfig]="{ placeholder: 'Select a version...' }"
                        [options]="filteredVersionOptions()"
                        [ngModel]="filters().version"
                        (optionSelected)="onVersionChange($event)"
                        [showClearAll]="true"
                ></ds-select>
            </ds-form-field>
        </div>

        <div class="col-md-2">
            <ds-form-field>
                <label ds-label for="carModel1" class="form-label">Model</label>
                <ds-select
                        id="carModel1"
                        [labellingConfig]="{ placeholder: 'Select a model...' }"
                        [options]="filteredModelOptions()"
                        [ngModel]="filters().model"
                        (optionSelected)="onModelChange($event)"
                        [showClearAll]="true"
                ></ds-select>
            </ds-form-field>
        </div>

        <div class="col-md-2">
            <ds-form-field>
                <label ds-label for="storageLocationFilter" class="form-label">Storage Location<span style="color: red">*</span></label>
                <ds-select
                        id="storageLocationFilter"
                        [labellingConfig]="{ placeholder: 'Select a location...' }"
                        [options]="storageLocationOptions"
                        [ngModel]="filters().storageLocation"
                        (optionSelected)="onStorageLocationChange($event)"
                        [showClearAll]="true"
                        required
                ></ds-select>
            </ds-form-field>
        </div>

        <div class="col-md-3">
            <div class="search-button-container align_btn">
                <button
                        ds-button
                        ds-loading
                        class="btn btn-primary"
                        icon="search"
                        (click)="loadReplenishmentData()"
                        [disabled]="!isBrandSelected() || !isStorageLocationSelected()"
                >
                    Search
                </button>
            </div>
        </div>
    </div>
</div>
<br />

@if (hasSearched()) {
    @if (rowsData().length > 0) {
        <div class="content_bg styled-section">
            <div class="scrollable-table-wrapper">
                <div class="table-section">
                    <div class="table-scroll-container">
                        <table class="ds-table zebra-table fixed-header-table">
                            <thead class="table-head">
                            <tr>
                                @for (column of columnData; track column.field) {
                                    <th>{{ column.headerName }}</th>
                                }
                            </tr>
                            </thead>
                            <tbody>
                                @for (row of rowsData(); track row.VIN) {
                                    <tr>
                                        @for (column of columnData; track column.field) {
                                            <td>
                                                @switch (column.field) {
                                                    @case ('optionCount') {
                                                        @if (row.options?.length) {
                                                            <span
                                                                    style="cursor: pointer; text-decoration: underline"
                                                                    [ds-popover-trigger-for]="popover"
                                                            >
                                {{ row.options.length }}
                              </span>
                                                            <ds-popover #popover>
                                                                <ds-box-header>Options</ds-box-header>
                                                                <ds-box-content>
                                                                    @for (opt of row.options; track opt.optionCode) {
                                                                        <div>{{ opt.optionCode }} - {{ opt.optionDescription }}</div>
                                                                    }
                                                                </ds-box-content>
                                                            </ds-popover>
                                                        } @else {
                                                            0
                                                        }
                                                    }

                                                    @case ('download') {
                                                        <ds-icon
                                                                icon="exchange"
                                                                size="md"
                                                                (click)="openRtpUploadDownloadModal(row)"
                                                                title="Request Vehicle"
                                                                style="cursor: pointer; color: #037493"
                                                                class="action transfer"
                                                        ></ds-icon>
                                                    }

                                                    @case ('VIN') {
                                                        <a
                                                                [href]="row[column.field] | unitOverviewLink"
                                                                target="_blank"
                                                                rel="noopener"
                                                                style="font-weight: bold; color: #037493; text-decoration: none; cursor: pointer;"
                                                                title="View Unit Overview"
                                                        >
                                                            {{ row[column.field] }}
                                                        </a>
                                                    }

                                                    @default {
                                                        {{ row[column.field] }}
                                                    }
                                                }
                                            </td>
                                        }
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    } @else {
        <div class="no-data-message" style="display: flex; align-items: center; justify-content: center; height: 45vh; min-height: 450px; text-align: center; padding-left: 2rem;">
            <div>
                <h1 style="margin: 0">NO SEARCH RESULTS FOUND</h1>
                <p style="margin: 0">Try adjusting your search criteria in the filters.</p>
            </div>
        </div>
    }
} @else {
    <div class="no-data-message" style="display: flex; align-items: center; justify-content: center; height: 45vh; min-height: 450px; text-align: center; padding-left: 2rem;">
        <div>
            <h1 style="margin: 0">NO SEARCH RESULTS YET</h1>
            <p style="margin: 0">Use the filters and click 'Search' to find what you need.</p>
        </div>
    </div>
}

<ds-modal
    #StockReplshModal
    [dimensionsConfig]="{ width: '420px' }"
    [ds-modal-trigger-for]="StockReplshModal"
    [(isModalOpen)]="StockReplshModalIsOpen"
    [detachFooter]="true"
>
    <ds-box-header style="font-size: xx-large; font-weight: bold">
        Request Replenishment Vehicle
    </ds-box-header>
    <ds-box-content>
        <div style="display: flex; align-items: center; gap: 8px">
            <span style="width: 150px">Vehicle:</span>
            <span>{{ modalData().description }}</span>
        </div>
        <br />
        <div style="display: flex; align-items: center; gap: 8px">
            <span style="width: 150px">VIN Number:</span>
            <span>{{ modalData().vin }}</span>
        </div>
    </ds-box-content>
    <ds-box-footer>
        <button
                ds-button
                class="primary-modal-btn"
                (click)="requestVehicle()"
        >
            Request Vehicle
        </button>
    </ds-box-footer>
</ds-modal>

<app-eye-modal></app-eye-modal>
